import React from 'react';
import { AuthContextType } from './authentication.types';

const AuthenticationContext = React.createContext<AuthContextType | undefined>(undefined);

export { AuthenticationContext };
